<script setup lang="ts">
import { cn } from '@/shadcn/lib/utils'
import { Circle } from '@lucide/vue'
import {
  DropdownMenuItemIndicator,
  DropdownMenuRadioItem,
  type DropdownMenuRadioItemEmits,
  type DropdownMenuRadioItemProps,
  useForwardPropsEmits,
} from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<DropdownMenuRadioItemProps & { class?: HTMLAttributes['class'] }>()

const emits = defineEmits<DropdownMenuRadioItemEmits>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DropdownMenuRadioItem
    data-slot="dropdown-menu-radio-item"
    v-bind="forwarded"
    :class="cn(
      `
        tw:focus:bg-accent
        tw:focus:text-accent-foreground
        tw:relative
        tw:flex
        tw:cursor-default
        tw:items-center
        tw:gap-2
        tw:rounded-sm
        tw:py-1.5
        tw:pr-2
        tw:pl-8
        tw:text-sm
        tw:outline-hidden
        tw:select-none
        tw:data-[disabled]:pointer-events-none
        tw:data-[disabled]:opacity-50
        tw:[&_svg]:pointer-events-none
        tw:[&_svg]:shrink-0
        tw:[&_svg:not([class*='size-'])]:size-4
      `,
      props.class,
    )"
  >
    <span class="tw:pointer-events-none tw:absolute tw:left-2 tw:flex tw:size-3.5 tw:items-center tw:justify-center">
      <DropdownMenuItemIndicator>
        <Circle class="tw:size-2 tw:fill-current" />
      </DropdownMenuItemIndicator>
    </span>
    <slot />
  </DropdownMenuRadioItem>
</template>
